import router from "@/router";

const commons = {};

commons.api_host = "https://api.kumob.cn/jobs";

// 云简历相关接口文档
// https://docs.apipost.cn/view/6cf90d41de0528dd
// 密码: $RFV5tgb

commons.template_list = commons.api_host + "/api/template/list"    //模版列表,基本信息，不含模版内容     {"user_id": "sys"}   //用户ID，sys为系统模版
commons.base_model_list = commons.api_host + "/api/model/list"   //读取系统基本模块列表
commons.base_model_load = commons.api_host + "/api/model/load"   //读取系统基本模块信息   {"id": "edu"}  //模块ID

commons.template_create = commons.api_host + "/api/template/create"   //根据已有模版，创建新模版。 {"template_id": "sys_001","user_id": "[userID]"}
commons.template_cv_review = commons.api_host + "/api/out/doc"    //简历预览  {template_id:""}
commons.template_set = commons.api_host + "/api/template/set_template"   //修改模版名称。 {"template_id": "","title": ""}
commons.template_delete = commons.api_host + "/api/template/delete"   //删除模版,数据不删除。 {"template_id": ""}

commons.template_model_add = commons.api_host + "/api/template/add_model"      //添加一个模块到模版中，不含数据   {"template_id": "96C5707663020CCC76DFF67BD6D4A31A","model_id": "intern","user_id": "[userID]"}
commons.template_model_list = commons.api_host + "/api/template/load"   //读取模版模块结构，含排序信息。   {"template_id": "96C5707663020CCC76DFF67BD6D4A31A"}
commons.template_model_delete = commons.api_host + "/api/template/delete_model"   //删除模版中的某一个模块   {"template_id": "96C5707663020CCC76DFF67BD6D4A31A","model_id": "intern"}
commons.template_model_set = commons.api_host + "/api/template/set_model"     //重新设置模块名称  {template_id:'',model_id:'',title:''}

commons.template_model_data_load = commons.api_host + "/api/template/data/load"    //读取某一模版下某一模块的数据列表，row_id可指定读出一行数据。  "template_id": "96C5707663020CCC76DFF67BD6D4A31A","model_id": "intern","row_id": "222222"}
commons.template_model_data_create = commons.api_host + "/api/template/data/create"   //创建某模版下某模块的数据结构,不创建数据  {"template_id": "96C5707663020CCC76DFF67BD6D4A31A","model_id": "intern","user_id":"[userID]"}
commons.template_model_data_save = commons.api_host + "/api/template/data/save"      //保存某模版下某一模块数据   提交数据局在create接口返回基础上加 fieldValue,以及user_id, user_id必须有
commons.template_model_data_delete = commons.api_host + "/api/template/data/delete"   //删除某一模版下某一模块下的指定行数据  {"template_id": "96C5707663020CCC76DFF67BD6D4A31A","model_id": "intern","row_id": "111111"}
//照片上传地址 https://api.wapg.cn/jobs/commons/image/upload
commons.upload_img_url = commons.api_host + "/commons/image/upload";

commons.get_wx_user_info_url = "https://api.kumob.cn/wx/api/user/web_user_info/quick";
commons.get_wx_id_info_url = "https://api.kumob.cn/wx/api/user/open_id";

commons.jobs_corp_info = commons.api_host + "/api/corp/info"  //{id:""}  企业主信息
commons.jobs_list = commons.api_host + "/api/jobs/list"  //{corp_id:""}  招聘职位列表
commons.jobs_view_list = commons.api_host + "/api/jobs/view_list"  //{corp_id:""}  招聘职位列表
commons.jobs_info = commons.api_host + "/api/jobs/info"  //{id:""}  招聘职位信息
commons.jobs_view_info = commons.api_host + "/api/jobs/view_info"  //{id:""}  招聘职位信息
commons.jobs_cv_submit = commons.api_host + "/api/jobs/cv_submit"  //{corp_id:"",job_id:"",user_id:'',cv_id:'',doc_url:''}  招聘职位信息

commons.jobs_doc_upload = commons.api_host + "/api/file/upload"


//格式化时间
commons.dateFormat = function (fmt, date) {
    //author: meizz
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
            );
    return fmt;
};

commons.getUrlKey = function (name) {
    return (
        decodeURIComponent(
            (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                location.href
            ) || ['', ""])[1].replace(/\+/g, "%20")
        ) || null
    );
};

commons.getUrlKey2 = function (url, name) {
    return (
        decodeURIComponent(
            (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                url
            ) || ['', ""])[1].replace(/\+/g, "%20")
        ) || null
    );
};

commons.goto = function (page) {
    router.push(page);
}

/**
 * 获取重定向url（编码后）
 */
commons.getRedirectUrl = function (url) {
    //redirect_url
    return encodeURIComponent(url)
};

//js对象复制，排除空值和-1的
commons.copyObj = function (obj) {
    let _data = {};
    for (let k in obj) {
        let keyType = typeof (obj[k]);
        let keyValue = obj[k];

        // let isCopy = false;
        if (keyType === 'number' && keyValue > -1) {
            // isCopy = true;
            _data[k] = parseInt(keyValue);
        }
        if (keyType === 'string' && keyValue && keyValue.length > 0) {
            // isCopy = true;
            _data[k] = keyValue;
        }
        if (keyType === 'object') {
            _data[k] = keyValue;
        }
        if (keyType === 'boolean') {
            _data[k] = keyValue;
        }
    }
    return _data;
};


export default commons;

